import React from "react"
import { MDXProvider } from "@mdx-js/react"

import Collapse from "./Collapse"

const components = {
  collapse: Collapse
}

interface DataProps {
  children: React.ReactNode
}

export const MarkdownProvider: React.FC<DataProps> = ({ children }) => (
  <MDXProvider components={components}>{children}</MDXProvider>
)
